import React, { useState, useEffect } from 'react';
import BusinessesTable from './BusinessesTable';


interface BusinessesProps {
  email: string;
  loggedIn: boolean;
  token: string;
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  baseUrl: string;
}

const Businesses: React.FC<BusinessesProps> = ({ email, loggedIn, token, setLoggedIn, setEmail, baseUrl }) => {
  const [businessesData, setBusinessesData] = useState< Array<{ 
    updated_at: string, 
    business_id: string, 
    external_business_id: string, 
    signed_up: boolean,
    pre_approved: boolean,
    currency: string,
    maximum_amount: number,
    available_amount: number,
    expires_at: string,
    redemption_token: string,
    active_advance: boolean
  }> >([] );
    const [loading, setLoading] = useState<boolean>(true); // Loading state
    const [responseMessage, setResponseMessage] = useState<string>('');


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await fetch(baseUrl + 'businesses', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'jwt-token': token,
          },
        });

        const data = await response.json();
        console.log(data);

        if (data) {
          setBusinessesData(data); // Update state with fetched data
        } else {
          console.error("Error: No items found");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchData(); // Call the fetchData function
  }, [token]); // Dependency array: re-fetch only if token changes


  async function updateReport() {
    try {
      const response = await fetch(baseUrl + 'reports?type=business_eligibility', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'jwt-token': token,
        },
      });
  
      const data = await response.json();
      console.log(data);
  
      if (data.$metadata.httpStatusCode == 200) {
        console.log("report updated");
        setResponseMessage("Businesses updated with eligibility report");
      } else {
        console.error("Error: Something wrong");
        setResponseMessage("Error: Something wrong");
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } 
  }
  
 

  return (
    <div>
      <div className={'titleContainer'}>
        <div>Businesses</div>
      </div>
      <div className={'right-aligned-div'}>
      <br />
      <input className="inputButton" type="button" onClick={updateReport} value="Update" /><br />
      {responseMessage}
      </div>
      <br />
      <div><BusinessesTable businessData={businessesData}/></div>
    </div>
  );
};

export default Businesses;
